import _ from 'lodash'
import codes from './_common/errorCodes.json'
import Vue from 'vue';

const DEFAULT_LANG = 'en'
const DEFAULT_ERROR_CODE = 1000

let $t = () => {}

const translator = (code, params) => {
    return Vue.prototype.$translateService?.translateImmediately(`errors:${code}`, null, params)
}

if (Vue.prototype.$translateService) $t = translator

export default {
    getTextByCode({code, defaultText, params, lang = DEFAULT_LANG}) {
        if (!defaultText) defaultText = codes[DEFAULT_ERROR_CODE]

        // if (code >= 1000 && code < 2000) code = DEFAULT_ERROR_CODE
        if (!codes[code]) code = DEFAULT_ERROR_CODE

        let message = defaultText
        if (lang === DEFAULT_LANG) {
            message = codes[code]
            if (params && Object.keys(params).length > 0) {
                try {
                    let tpl = _.template(message);
                    message = tpl(params);
                } catch (e) {
                    message = defaultText
                }
            }

        } else {
            try {
                message = $t(code, params)
            } catch (e) {
                message = $t(DEFAULT_ERROR_CODE)
            }
        }

        return message
    },
    setTranslator(val) {
        $t = val
    }
};